import App from './App';
import { defineCustomElements as bzmHeader } from '@blazemeter/bzm-header/dist/loader';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from 'store/configureStore';
import '@blazemeter/blaze-ct-ui-components/dist/blaze-ct-ui-components.css';
import '@blazemeter/blaze-data-ui/dist/blaze-data-ui.css';
import { BrowserRouter } from 'react-router-dom';
import { BlazemeterUserConfig } from 'types/rest/blazeMeterApiResponse';

// On Private Cloud, we need '/mock/' prefix for all calls.
declare let PRELOADED_BLAZE_USER_CONFIG: BlazemeterUserConfig | null;
let basename = '/';
if (PRELOADED_BLAZE_USER_CONFIG !== null && PRELOADED_BLAZE_USER_CONFIG!.config !== null) {
  basename = PRELOADED_BLAZE_USER_CONFIG!.config.isPrivateCloudRequest ? '/mock/' : '/';
}

bzmHeader(window);

ReactDOM.render(
  <BrowserRouter basename={basename}>
    <Provider store={store as any}>
      <App />
    </Provider>
  </BrowserRouter>,
  document.getElementById('root'),
);
